import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { InstructionNodeProps } from "./InstructionNodeFactory";
import { getInstructionDisplay } from "../../../../../constants/InstructionLabels";
import { TreeNode, TreeNodeLabel } from "../TreeNode";
import { InstructionCategory } from "../../../../../machinelogic/instruction_types";

// Same as RobotLoopNode.tsx, but without robotParameters dependency. This component is temporary
// until we can consolidate robot and vse state.
export const RobotLoopNodeSimple: FC<InstructionNodeProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {
  const { name, icon } = getInstructionDisplay(instruction);

  if (instruction.category !== InstructionCategory.ROBOT_LOOP) {
    throw new Error(`tried to render RobotLoopNode with instruction that is not of category ${InstructionCategory.ROBOT_LOOP}: ${instruction}`);
  }

  const lInstructionLabel = <TreeNodeLabel
    icon={icon}
    name={name}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode
      title={lInstructionLabel}
    >
      {instruction.parameters.sequenceName &&
        <TreeNode
          title={<TreeNodeLabel name={instruction.parameters.sequenceName} onClick={onClick} />}
          titleClassName={titleClassName}
        />
      }
    </TreeNode>
  );
});